import { MinzeElement } from 'minze'

export interface LvcCircleCheckSelectLargeIcon {}

export class LvcCircleCheckSelectLargeIcon extends MinzeElement {
  html = () => `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#1E007D"/>
    <path d="M33.8 17C29.4769 21.2457 25.1812 25.9772 21.1082 30.4946C20.8545 30.776 20.4226 30.8043 20.1344 30.5582C17.8324 28.5917 16.1562 27.091 14.2 24.6147" stroke="#FF4600" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
